import { Grid } from '@material-ui/core'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

interface IMoneyValueProps {
  isDebit: boolean
}

export const ContainerItem = styled.div`
  display: flex;
  padding: 15px;

  height: 102px;

  align-items: center;
`

export const GridContainer = styled(Grid)`
  height: 61px;
`

export const TextTime = styled.p`
  color: ${colors.grayLight};
  font-size: 12px;
  font-weight: 500;
`

export const TextType = styled.p`
  color: ${colors.grayDark};
  font-size: 12px;
  line-height: 20px;

  margin: 5px 0px;
`

export const TextDoc = styled.p`
  color: ${colors.blue};
  font-size: 12px;
  font-weight: 700;

  & > span {
    color: ${colors.grayDark};
    font-size: 12px;
    font-weight: 400;
  }
`

export const CardType = styled.div`
  display: flex;

  align-items: center;
  justify-content: center;

  width: 50px;
  height: 16px;

  background: ${colors.blue};

  font-size: 8px;
  color: ${colors.white};

  border-radius: 2px;

  text-transform: uppercase;
`

export const MoneyValue = styled.span<IMoneyValueProps>`
  color: ${props => (props.isDebit ? colors.red : colors.green)};
  font-size: 12px;
  font-weight: 700;
`
